import request from '../utils/fetch'
import { stringify } from 'qs'

const ENTRY = '/devices-properties'
const UPDATE_DEVICE_PROPERTY_ENTRY = '/users-control-devices'

export const getDevicePropertyByDeviceIds = ids => {
  const query = {
    _id: {
      $in: ids
    }
  }
  const queryString = stringify(query)
  return request(ENTRY + `?${queryString}`, {
    method: 'GET'
  })
}

export const getAllDeviceProperties = () => {
  return request(ENTRY, {
    method: 'get'
  })
}

export const updateDeviceProperty = data => {
  const url = `${UPDATE_DEVICE_PROPERTY_ENTRY}`
  return request(url, {
    method: 'POST',
    body: JSON.stringify(data)
  })
}
